
import mixin from "./mixin";
import * as modals from "@/lib/modals";
import TruckModule from "@/store/modules/truck";
import { getModule } from "vuex-module-decorators";
import { Component, Mixins } from "vue-property-decorator";
import notifications from "../../../lib/notifications";
import { formatDate } from "../../../utils";
import { UnfinalizeTruckResponse } from "@/models/api/trucks/finalizeTrucks";

const truckModuleState = getModule(TruckModule);

@Component({ name: modals.unfinalizeTruckModal })
export default class UnfinalizeTruckModal extends Mixins(mixin) {
  response: UnfinalizeTruckResponse = null;
  loading: boolean = true;
  unfinalizing: boolean = false;
  canUnfinalize: boolean = false;
  deliveryDateFormatted: string = null;
  truckId: number = null;
  async load() {
    this.show();

    let selectedTruck = this.selectedItem;
    this.truckId = selectedTruck.id;

    try {
      this.response = await truckModuleState.unfinalizeTruck({
        truckId: this.truckId
      });

      this.deliveryDateFormatted = formatDate(this.response.deliveryDate);

      this.canUnfinalize = this.response.canUnfinalize;
    } catch (ex) {}

    this.loading = false;
  }

  async finalizeTruck() {
    this.unfinalizing = true;
    try {
      const response = await truckModuleState.unfinalizeTruck({
        truckId: this.truckId,
        confirm: true
      });

      notifications.success("Unfinalize Truck", "Truck successfully unfinalized.");

      this.hideModal();
    } catch (ex) {
      notifications.error("Unfinalize Truck", "Failed to unfinalize truck", ex);
    }

    this.unfinalizing = false;
  }

  reset() {
    this.response = null;
    this.loading = true;
    this.unfinalizing = false;
    this.canUnfinalize = false;
    this.truckId = null;
    this.deliveryDateFormatted = null;
  }
}
